import { CalendarDateTime } from '@internationalized/date';
import type { DateValue } from 'react-aria-components';

export function formatDateValue(value: DateValue | null | undefined): string {
  if (!value) return '';
  return `${value.month}/${value.day}/${value.year}`;
}

export function formatTimeValue(
  value: DateValue | null | undefined,
  granularity: string,
  hourCycle: 12 | 24 = 12
): string {
  if (!value || !('hour' in value)) return '';
  const dt = value as CalendarDateTime;

  let h: string;
  let suffix = '';
  if (hourCycle === 12) {
    const period = dt.hour >= 12 ? 'PM' : 'AM';
    const h12 = dt.hour % 12 || 12;
    h = String(h12);
    suffix = ` ${period}`;
  } else {
    h = String(dt.hour).padStart(2, '0');
  }

  const m = String(dt.minute).padStart(2, '0');
  if (granularity === 'second') {
    const s = String(dt.second).padStart(2, '0');
    return `${h}:${m}:${s}${suffix}`;
  }
  if (granularity === 'minute') return `${h}:${m}${suffix}`;
  return `${h}${suffix}`;
}
